import axios from "axios";
import config from "config";
import { i18nService } from "services/i18n/I18nService";
import { EntityType, ISearchData, IToolSearchData } from "types";
import { ISearchResults } from "types";

export class SearchService {
  static search = (data: ISearchData): Promise<ISearchResults> =>
    new Promise(async (resolve, reject) => {
      try {
        const request = await axios({
          url:
            data.type === EntityType.subTool
              ? config.API.TOOLBOX_SEARCH
              : config.API.SEARCH,
          method: "get",
          params: {
            o: (data.page - 1) * (data.amount || 1),
            ...(data.amount && { a: data.amount }),
            q: {
              langcode: i18nService.currentLanguage,
              term: data.query,
              type: data.type || undefined,
              facets: data.facets,
              prioritiseDossiersAndTools: data.prioritiseDossiersAndTools,
            },
          },
        });

        // not really an error but let's catch it
        if (request.data.err) {
          return reject({
            error: request.data.err,
          });
        }

        resolve(request.data as ISearchResults);
      } catch (error) {
        reject({
          error: error.response?.statusText,
        });
      }
    });

  static searchTools = (data: IToolSearchData): Promise<ISearchResults> =>
    new Promise(async (resolve, reject) => {
      try {
        const request = await axios({
          url: config.API.TOOL_SEARCH,
          method: "get",
          params: {
            o: (data.page - 1) * data.amount,
            a: data.amount,
            q: {
              langcode: i18nService.currentLanguage,
              term: data.term,
              facets: data.facets,
            },
          },
        });

        // not really an error but let's catch it
        if (request.data.err) {
          return reject({
            error: request.data.err,
          });
        }

        resolve(request.data as ISearchResults);
      } catch (error) {
        reject({
          error: error.response?.statusText,
        });
      }
    });
}
